<template>
  <div
    v-loading="fetchProgramsInProgress"
    class="main-dashboard-panel organization-reports"
  >
    <div class="panel-topnav">
      <ul class="nav nav-tabs">
        <li>
          <h3 class="page-title">Reports</h3>
        </li>
        <li>
          <el-select
            v-model="selectedProgramId"
            class="program-select"
            placeholder="Select program"
            @change="onProgramChange"
          >
            <el-option
              v-for="p in programs"
              :key="p.id"
              :label="p.name + (p.is_active ? ' (Active)' : '')"
              :value="p.id"
            />
          </el-select>
        </li>
      </ul>
      <div class="clearfix" />
    </div>
    <ProgramReport v-if="program" :program="program" :demo="demoMode" />
    <el-card v-else>
      <el-alert
        title="Please choose a program to show reports for"
        show-icon
        :closable="false"
      />
    </el-card>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import ProgramReport from '@/components/organizations/program-reports/ProgramReport.vue'
import { useStore } from '@/store'
import { orderBy } from 'lodash'

export default {
  components: {
    ProgramReport,
  },
  setup() {
    const store = useStore()
    const fetchProgramsInProgress = ref(true)

    const programs = computed(() => {
      return orderBy(
        store.state.organizationProgramList.programs,
        ['is_active', 'activated_at'],
        ['desc', 'desc'],
      )
    })
    const program = ref(null)
    const selectedProgramId = ref(null)
    const user = ref(null)
    const demoMode = ref(false)

    ;(async () => {
      user.value = await store.dispatch('user/getUser')

      const orgId = user.value.organizationId
      const org = user.value.organizations.filter((o) => o.id === orgId)[0]
      demoMode.value = org.has_demo_mode_enabled_reports

      await store.dispatch('organizationProgramList/fetch', {
        organizationId: orgId,
      })

      const activePrograms = programs.value.filter((p) => p.is_active)
      if (activePrograms.length) {
        program.value = activePrograms[0]
      } else if (programs.value.length > 0) {
        program.value = programs.value[0]
      }

      if (program.value) {
        selectedProgramId.value = program.value.id
      }
      fetchProgramsInProgress.value = false
    })()

    const onProgramChange = (programId) => {
      if (programId) {
        program.value = programs.value.filter((p) => p.id === programId)[0]
      }
    }

    return {
      fetchProgramsInProgress,
      selectedProgramId,
      program,
      programs,
      onProgramChange,
      demoMode,
    }
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';
@import '~assets/css/vars.scss';

.organization-reports {
  .program-select {
    margin-top: 11px;
    width: 300px;
  }
}
</style>
